/// <reference types="vite/client" />

// Alpine
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'

Alpine.plugin(intersect)

// Theme
import * as Theme from './default/theme'

// Components
import {
    initCollapsible,
    initLightbox,
    initHero,
    initImagesSlider,
    initMenuToggle,
    initNavigationSlider,
    initNewsletter,
    initOrderArticle,
    initQuoteSlider,
    initShowButton,
    initShowOverview,
    initShowsSlider,
    initShowStatus,
    initSubmenu,
    initSocialShare,
    initSearchResults,
    initWhatsapp,
    initWishlist,
} from './default/components'

import { initHeader } from './cultura-nova/components/header.ts'
import { initImageSlider } from './cultura-nova/components/sliders'
import { initShowOverview } from './cultura-nova/components/show-overview.ts'

window.itixBackendUrl = document.querySelector('body > header[data-itix-backend-url]')?.dataset.itixBackendUrl || ''

Theme.initIntersectObserver()
Theme.initJSEssentials()
Theme.initSpeculationRules()

initCollapsible()
initHeader()
initHero()
initImageSlider()
initImagesSlider()
initLightbox()
initMenuToggle()
initNavigationSlider()
initNewsletter()
initOrderArticle()
initQuoteSlider()
initShowButton()
initShowOverview()
initShowsSlider()
initShowStatus()
initSubmenu()
initSocialShare()
initSearchResults()
initWhatsapp()
initWishlist()

Alpine.start()

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}
